import { createContext } from "react";
export const Privacy = createContext(false);
